export default __webpack_public_path__ + "static/media/close.4e066aa8.svg";